import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBookOpen';
/** Renders an SVG icon. */
const SvgBookOpen = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M25.465 7.03a9 9 0 0 0-6.497.604L17 8.618v15.995l2.444-.815a11 11 0 0 1 5.034-.454l3.522.503V7.755zM15 24.613V8.618l-1.968-.984a9 9 0 0 0-6.497-.604L4 7.755v16.092l3.522-.503a11 11 0 0 1 5.034.454zm1-17.73 2.074-1.038a11 11 0 0 1 7.94-.738l2.535.724A2 2 0 0 1 30 7.755v16.092a2 2 0 0 1-2.283 1.98l-3.521-.503a9 9 0 0 0-4.12.371l-3.76 1.254a1 1 0 0 1-.632 0l-3.76-1.254a9 9 0 0 0-4.12-.371l-3.521.503A2 2 0 0 1 2 23.847V7.755A2 2 0 0 1 3.45 5.83l2.535-.724a11 11 0 0 1 7.941.738L16 6.882ZM6 13a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m13 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M6 17a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m13 0a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgBookOpen.displayName = displayName;
export default SvgBookOpen;
